export default __webpack_public_path__ + "static/media/plotterKnife.8da98e3c.png";